import React, { memo } from 'react';
import { IconClear } from '@app/icons';
import { Oked } from '@app/models';

interface Props {
  list: Oked[];
  onClickClear?: (number: number) => void;
}

function StyledOkedListBlock({ list, onClickClear }: Props) {
  return (
    <div className="flex flex-wrap ml-[-16px] mt-[-16px]">
      {list?.map((item, index) => (
        <div
          key={index}
          className="bg-[#f5f5f5] rounded-lg gap-2 flex items-center px-4 mt-4 ml-4 h-min box-border"
        >
          <p className="font-normal text-base leading-6 text-[#0a0a0a] max-w-[500px] truncate m-0">
            {item.nameRu}
          </p>
          {!!onClickClear && (
            <IconClear
              className="ml-2 cursor-pointer"
              onClick={() => onClickClear(index)}
            />
          )}
        </div>
      ))}
    </div>
  );
}

export default memo(StyledOkedListBlock);
